import { TFunction } from "i18next";
import { PageBlockDto } from "~/modules/pageBlocks/dtos/PageBlockDto";
import { defaultFooter } from "../defaultFooter";
import { defaultHeader } from "../defaultHeader";
import Constants from "~/application/Constants";
import { defaultTestimonials } from "../defaultTestimonials";
import { defaultGallery } from "../defaultGallery";
import { defaultFaq } from "../defaultFaq";

export function defaultLandingPage({ t }: { t: TFunction }) {
  const blocks: PageBlockDto[] = [
    // // Banner
    // {
    //   banner: {
    //     style: "top",
    //     text: "Get early access to Lunova Alerts!",
    //     textMd: "Sign up now to get early access to Lunova Alerts!",
    //     cta: [{ text: "Join!", href: "/contact", isPrimary: true, target: "_blank" }],
    //   },
    // },
    // Header
    { header: defaultHeader({ t }) },
    // Hero
    {
      hero: {
        style: "rightImage",
        headline: t("front.hero.headline1"),
        description: t("front.hero.headline2"),
        secondaryBadgeUrl: `${process.env.SUPABASE_API_URL}/storage/v1/object/public/public-image//quickbook%20badge.png`,
        image: `${process.env.SUPABASE_API_URL}/storage/v1/object/public/public-image//lunova%20hero%20landing%20page.png`,
        cta: [
          {
            text: t("front.hero.buy"),
            href: "/pricing",
            isPrimary: true,
          },
          {
            text: t("front.hero.contact"),
            href: "/contact",
            isPrimary: false,
          },
        ],
        topText: {
          text: t("front.hero.subheadline1"),
          // link: { text: t("front.hero.changelog"), href: "/changelog" },
        }
        // bottomText: {
        //   link: {
        //     text: t("front.hero.hint", { 0: `v${Constants.VERSION}` }),
        //     href: "/changelog",
        //   },
        // },
      },
    },
    {
      video: {
        style: "full",
        headline: "Watch A Demo",
        src: "https://www.loom.com/embed/f4315d430e3541149aba200ceda4dc2d?sid=648ef383-8c23-474e-ba85-9bb6131bb607",
      },
    },
    {

      features: {
        style: "list",
        topText: "",
        headline: "Features",
        cta: [
          { text: "Pricing", isPrimary: true, href: "/pricing" },
          { text: "Contact", isPrimary: false, href: "/contact" },
        ],
        grid: {
          columns: "4",
          gap: "sm",
        },
        items: [
          {
            name: "Customizable alert system to notify users of critical financial events.",
          },
          {
            name: "Real-time monitoring to ensure compliance and proactive financial management.",
          },
          {
            name: "Real-time updates between Lunova and QuickBooks to ensure data accuracy.",
          },
          {
            name: "Real-time updates between Lunova and QuickBooks to ensure data accuracy.",
          }
        ],
      },
    },
    // Gallery
    {
      gallery: {
        style: "carousel",
        items: defaultGallery,
      },
    },
    // // Logo Clouds
    // {
    //   logoClouds: {
    //     style: "custom",
    //     headline: t("front.logoClouds.title"),
    //     logos: [
    //       {
    //         alt: "Remix",
    //         href: "https://remix.run/ref=saasrock.com",
    //         src: "https://yahooder.sirv.com/saasrock/logos/clouds/colors/remix.png",
    //       },
    //       {
    //         alt: "Tailwind CSS",
    //         href: "https://tailwindcss.com/ref=saasrock.com",
    //         src: "https://yahooder.sirv.com/saasrock/logos/clouds/colors/tailwindcss.png",
    //       },
    //       {
    //         alt: "Prisma",
    //         href: "https://www.prisma.io/?via=alexandro",
    //         src: "https://yahooder.sirv.com/saasrock/logos/clouds/colors/prisma.png",
    //       },
    //     ],
    //   },
    // },
    // // Testimonials
    {
      testimonials: {
        style: "scroll",
        headline: "Read what other business owners are saying about Lunova",
        items: defaultTestimonials,
      },
    },
    // Pricing
    {
      pricing: {
        style: "simple",
        headline: t("front.pricing.title"),
        subheadline: t("front.pricing.headline"),
      },
    },
    // // Community
    // {
    //   community: {
    //     style: "simple",
    //     headline: "Join the SaasRock community!",
    //     subheadline: "We're all looking to build successful SaaS applications.",
    //     withName: false,
    //     // grid: {
    //     //   columns: "12",
    //     //   gap: "sm",
    //     // },
    //     cta: [
    //       {
    //         text: "Subscribe",
    //         href: "/pricing",
    //       },
    //       {
    //         text: "Join Discord",
    //         href: "https://discord.gg/KMkjU2BFn9",
    //       },
    //       {
    //         text: "Youtube channel",
    //         href: "https://www.youtube.com/@saasrock",
    //       },
    //     ],
    //   },
    // },
    // Faq
    {
      faq: {
        style: "simple",
        headline: t("front.faq.title"),
        // subheadline: t("front.faq.subheadline"),
        items: defaultFaq({ t }),
      },
    },
    {
      blogPosts: {
        style: "simple",
        withCoverImage: true,
        withAuthorName: true,
        withAuthorAvatar: true,
        withDate: true,
        blogPath: "/blog",
        data: null,
      },
      layout: {},
    },
    // Footer
    {
      footer: defaultFooter({ t }),
    },
  ];
  return blocks;
}
